export const env = {
  lang: 'es'
};
